import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";
import {ImageCroppedEvent, ImageCropperComponent, LoadedImage} from "ngx-image-cropper";
import {TranslatePipe} from "@ngx-translate/core";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-profile-picture-cropper',
  standalone: true,
    imports: [
        TranslatePipe,
        ImageCropperComponent,
        NgIf
    ],
  templateUrl: './profile-picture-cropper.component.html',
  styleUrl: './profile-picture-cropper.component.scss'
})
export class ProfilePictureCropperComponent {

    @Input() imageChangedEvent: Event | null = null;
    croppedImage: SafeUrl = '';
    croppedBlob: Blob | null = null;

    isHoveringOnSelectImageButton: boolean = false;

    @Output() blobEventEmitter: EventEmitter<Blob | null> = new EventEmitter();

    constructor(private sanitizer: DomSanitizer) {
    }

    fileChangeEvent(event: Event): void {
        this.imageChangedEvent = event;
    }

    imageCropped(event: ImageCroppedEvent) {
        if (event.objectUrl) {
            this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
        }

        if (event.blob) {
            this.croppedBlob = event.blob;
        }
        // event.blob can be used to upload the cropped image
    }

    imageLoaded(image: LoadedImage) {
        // show cropper
    }

    cropperReady() {
        // cropper ready
    }

    loadImageFailed() {
        // show message
    }

    emitBlob(justClose: boolean) {
        if (!justClose) {
            this.blobEventEmitter.emit(this.croppedBlob)
        } else {
            this.blobEventEmitter.emit(null)
        }
    }

}
